import MuiListItemText from "@mui/material/ListItemText";

export default function ListItemText(props) {
  return <MuiListItemText {...props} />;
}
